module.exports = require('./dist/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/sayt/index.js
 ** module id = 196
 ** module chunks = 0
 **/